import { RoleEnum } from './RoleEnum';

export class User {
  public id?: string;
  public email?: string;
  public password?: string;
  public fullname?: string;
  public role?: RoleEnum;
  public createdDate?: Date;
  public lastActive?: Date;
  public status?: string;

  constructor(init?: Partial<User>) {
    Object.assign(this, init);
  }
}
